import { http } from 'connex-cds';

export default {
  listCarriers: ({ entityRef }) => http.get({ apiName: 'mt', path: `/${entityRef}/master-data/carriers` }),
};
